import { MOSTRAR_PROMOCIONES } from './action-types';
import promocionesApi from '../../api/payment';

function obtenerPromocionesSuccess(data) {
  return {
    type: MOSTRAR_PROMOCIONES,
    payload: data,
  };
}

export function obtenerPromociones() {
  return function action(dispatch) {
    return promocionesApi.obtenerPromocionesDePago()
      .then((res) => dispatch(obtenerPromocionesSuccess(res.data)))
      .catch((err) => {
        throw (err);
      });
  };
}

export function addPromotions(data) {
  return function action(dispatch) {
    return dispatch({
      type: MOSTRAR_PROMOCIONES,
      payload: data,
    });
  };
}
